<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.gradingScales.gradingScalesList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.gradingScales.gradingScalesList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="grading_scales.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.gradingScales.name')}}</th>
                                    <th>{{$t('form.gradingScales.gradingScaleType')}}</th>
                                    <th>{{$t('form.gradingScales.programCodes')}}</th>
                                    <th>{{$t('form.gradingScales.localGradingScale')}}</th>
                                    <th>{{$t('form.gradingScales.partnerCodes')}}</th>
                                    <th>{{$t('form.gradingScales.localGradeName')}}</th>
                                    <th class="text-right">{{$t('form.gradingScales.action')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(grading_scale, index) in grading_scales" v-bind:key="index" @dblclick="edit(index)">
                                    <td>{{grading_scale.name}}</td>
                                    <td>{{ grading_scale.grading_scale_type ? grading_scale.grading_scale_type.name : '' }}</td>
                                    <td>{{grading_scale.program_code}}</td>
                                    <td v-if="grading_scale.local_grading_scale == 1">True</td>
                                    <td v-else>False</td>
                                    <td>{{grading_scale.partner_code}}</td>
                                    <td>{{grading_scale.local_grade_name}}</td>

                                    <td class="text-right">
                                        <button
                                            class="btn btn-info btn btn-sm professorEdit"
                                            v-on:click="edit(index)">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        <button v-if="permissions.deleteEmployeeProfessors"
                                            class="btn btn-danger btn btn-sm"
                                            v-on:click="remove(index)">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["permissions"],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                grading_scales: [],

                pagination: {
                    current_page: 1
                }
            }
        },

        async mounted() {
            if (!this.permissions.viewSettingsGradingscale) {
                return this.$router.push('/');
            }

            this.fetch();
            
        },

        watch: {
            
        },

        methods: {
            paginate() {

                this.fetch();

            },

            fetch() {
                this.isLoading = true;

                axios
                    .get('/api/grading-scales?page=' + this.pagination.current_page)
                    .then((response) => {
                        this.grading_scales = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)

                        this.isLoading = false;
                    });
            },

            edit(index) {
                if (!this.permissions.viewSettingsGradingscale) return;

                let id = this.grading_scales[index].id;

                this.$router.push({
                    name: 'GradingScaleEdit',
                    params: {
                        id: id
                    }
                });
            },

            remove(index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;
                    axios
                        .delete('/api/grading-scales/' + this.grading_scales[index].id)
                        .then(response => {
                            this.isLoading = false;
                            this.grading_scales.splice(index, 1);
                            this.showAlert(response.data);
                            this.fetch();
                        })
                        .catch(error => {
                            this.isLoading = false;

                            this.showAlert(error.response.data.message, 'danger');
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
</style>
